var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlotselectInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BEBEBE",
    fillRule: "nonzero",
    d: "M35 3.5h-1.75V1.75a1.75 1.75 0 0 0-3.5 0V3.5h-7V1.75a1.75 1.75 0 0 0-3.5 0V3.5h-7V1.75a1.75 1.75 0 0 0-3.5 0V3.5H7a7 7 0 0 0-7 7V35a7 7 0 0 0 7 7h28a7 7 0 0 0 7-7V10.5a7 7 0 0 0-7-7zM7 7h1.75v1.75a1.75 1.75 0 0 0 3.5 0V7h7v1.75a1.75 1.75 0 0 0 3.5 0V7h7v1.75a1.75 1.75 0 0 0 3.5 0V7H35a3.5 3.5 0 0 1 3.5 3.5V14h-35v-3.5A3.5 3.5 0 0 1 7 7zm28 31.5H7A3.5 3.5 0 0 1 3.5 35V17.5h35V35a3.5 3.5 0 0 1-3.5 3.5zM10.875 26.25a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75zm0 7.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75zm6.75-7.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75zm0 7.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75zm6.75-7.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75zm0 7.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75zm7.5-7.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75zm0 7.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlotselectInactive);
export default __webpack_public_path__ + "static/media/slotselect-inactive.bfd76577ffe4673083809d9dc2423a8b.svg";
export { ForwardRef as ReactComponent };